/** Doctors must be adults; psychometrist checks the same (UserApplicationDraftRequest). */
export const MIN_APPLICANT_AGE = 18;

const pad = (n: number) => String(n).padStart(2, "0");

/** The latest birth date (local YYYY-MM-DD) of someone who is `age` today. */
export function latestBirthdate(age = MIN_APPLICANT_AGE, now = new Date()): string {
  const date = new Date(now.getFullYear() - age, now.getMonth(), now.getDate());
  // 29 Feb rolls over to 1 Mar in a non-leap year; the 28th is the right bound.
  if (date.getMonth() !== now.getMonth()) date.setDate(0);
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/** True for an ISO date at least `age` years back; ISO strings compare by date. */
export const isOldEnough = (birthdate: string, age = MIN_APPLICANT_AGE, now = new Date()) => birthdate <= latestBirthdate(age, now);
